
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const RightsContent = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Ihre Rechte</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-sm text-joerg-600">
        <div>
          <p className="leading-relaxed mb-4">
            Als betroffene Person haben Sie nach der DSGVO verschiedene Rechte, die sich insbesondere aus Art. 15 bis 21 DSGVO ergeben:
          </p>
          
          <div className="space-y-3">
            <div>
              <h4 className="font-medium text-joerg-700 mb-1">Auskunftsrecht (Art. 15 DSGVO)</h4>
              <p className="leading-relaxed">
                Sie haben das Recht, jederzeit Auskunft darüber zu verlangen, ob und welche personenbezogenen Daten wir über Sie verarbeiten. Wir werden Ihnen in diesem Fall eine Kopie der Daten zur Verfügung stellen.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium text-joerg-700 mb-1">Recht auf Berichtigung (Art. 16 DSGVO)</h4>
              <p className="leading-relaxed">
                Sie haben das Recht, die Berichtigung unrichtiger oder die Vervollständigung unvollständiger personenbezogener Daten zu verlangen.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium text-joerg-700 mb-1">Recht auf Löschung (Art. 17 DSGVO)</h4>
              <p className="leading-relaxed">
                Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen, wenn einer der in Art. 17 DSGVO aufgeführten Gründe zutrifft.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium text-joerg-700 mb-1">Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</h4>
              <p className="leading-relaxed">
                Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, wenn einer der in Art. 18 DSGVO aufgeführten Gründe zutrifft.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium text-joerg-700 mb-1">Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</h4>
              <p className="leading-relaxed">
                Sie haben das Recht, Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten und diese Daten an einen anderen Verantwortlichen übermitteln zu lassen.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium text-joerg-700 mb-1">Widerspruchsrecht (Art. 21 DSGVO)</h4>
              <p className="leading-relaxed">
                Sie haben das Recht, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einzulegen, wenn die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium text-joerg-700 mb-1">Beschwerderecht bei einer Aufsichtsbehörde</h4>
              <p className="leading-relaxed">
                Sie haben das Recht, sich bei der zuständigen Aufsichtsbehörde zu beschweren. Zuständig ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach.
              </p>
            </div>
          </div>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Kontakt</h4>
          <p className="leading-relaxed">
            Wenn Sie Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte haben, kontaktieren Sie uns bitte unter:<br /><br />
            Jörg Hörmann Coaching & Consulting<br />
            Grimmstr. 15<br />
            91154 Roth<br /><br />
            Telefon: 09171-9892118<br />
            E-Mail: info@joerg-hoermann.de
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default RightsContent;
